import { createPortal } from 'react-dom'
export const Portal = ({ node, children }) => createPortal(children, node)
